export default {
  form: document.querySelector('.header-form'),
  list: document.querySelector('#task-list'),
};
